import { render, staticRenderFns } from "./LotteryNew.vue?vue&type=template&id=4b3dcdcb&"
import script from "./LotteryNew.vue?vue&type=script&lang=js&"
export * from "./LotteryNew.vue?vue&type=script&lang=js&"
import style0 from "./LotteryNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports